/* tslint:disable */
/* eslint-disable */
/**
 * Project Freelancer API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
import type { ProjectDurationResource } from './';
import {
    ProjectDurationResourceFromJSON,
    ProjectDurationResourceFromJSONTyped,
    ProjectDurationResourceToJSON,
} from './';

/**
 * 
 * @export
 * @interface BriefDetailResource
 */
export interface BriefDetailResource {
    /**
     * 
     * @type {string}
     * @memberof BriefDetailResource
     */
    currency: string;
    /**
     * 
     * @type {string}
     * @memberof BriefDetailResource
     */
    projectType: BriefDetailResourceProjectTypeEnum;
    /**
     * 
     * @type {ProjectDurationResource}
     * @memberof BriefDetailResource
     */
    projectDuration: ProjectDurationResource;
    /**
     * 
     * @type {string}
     * @memberof BriefDetailResource
     */
    startDateType: BriefDetailResourceStartDateTypeEnum;
    /**
     * 
     * @type {Date}
     * @memberof BriefDetailResource
     */
    startDate?: Date;
    /**
     * 
     * @type {Date}
     * @memberof BriefDetailResource
     */
    endDate?: Date;
    /**
     * 
     * @type {string}
     * @memberof BriefDetailResource
     */
    workingStatus: BriefDetailResourceWorkingStatusEnum;
    /**
     * 
     * @type {number}
     * @memberof BriefDetailResource
     */
    dailyFreelancerRate?: number;
    /**
     * 
     * @type {number}
     * @memberof BriefDetailResource
     */
    remoteFrequency?: number;
}


/**
 * @export
 */
export const BriefDetailResourceProjectTypeEnum = {
    FixedPrice: 'FIXED_PRICE',
    TimeAndMaterials: 'TIME_AND_MATERIALS'
} as const;
export type BriefDetailResourceProjectTypeEnum = typeof BriefDetailResourceProjectTypeEnum[keyof typeof BriefDetailResourceProjectTypeEnum];

/**
 * @export
 */
export const BriefDetailResourceStartDateTypeEnum = {
    AsSoonAsPossible: 'AS_SOON_AS_POSSIBLE',
    ChosenDate: 'CHOSEN_DATE',
    Unknown: 'UNKNOWN'
} as const;
export type BriefDetailResourceStartDateTypeEnum = typeof BriefDetailResourceStartDateTypeEnum[keyof typeof BriefDetailResourceStartDateTypeEnum];

/**
 * @export
 */
export const BriefDetailResourceWorkingStatusEnum = {
    Remotely: 'REMOTELY',
    Hybrid: 'HYBRID',
    OnSite: 'ON_SITE'
} as const;
export type BriefDetailResourceWorkingStatusEnum = typeof BriefDetailResourceWorkingStatusEnum[keyof typeof BriefDetailResourceWorkingStatusEnum];


/**
 * Check if a given object implements the BriefDetailResource interface.
 */
export function instanceOfBriefDetailResource(value: object): value is BriefDetailResource {
    if (!('currency' in value) || value['currency'] === undefined) return false;
    if (!('projectType' in value) || value['projectType'] === undefined) return false;
    if (!('projectDuration' in value) || value['projectDuration'] === undefined) return false;
    if (!('startDateType' in value) || value['startDateType'] === undefined) return false;
    if (!('workingStatus' in value) || value['workingStatus'] === undefined) return false;
    return true;
}

export function BriefDetailResourceFromJSON(json: any): BriefDetailResource {
    return BriefDetailResourceFromJSONTyped(json, false);
}

export function BriefDetailResourceFromJSONTyped(json: any, ignoreDiscriminator: boolean): BriefDetailResource {
    if (json == null) {
        return json;
    }
    return {
        
        'currency': json['currency'],
        'projectType': json['projectType'],
        'projectDuration': ProjectDurationResourceFromJSON(json['projectDuration']),
        'startDateType': json['startDateType'],
        'startDate': json['startDate'] == null ? undefined : (new Date(json['startDate'])),
        'endDate': json['endDate'] == null ? undefined : (new Date(json['endDate'])),
        'workingStatus': json['workingStatus'],
        'dailyFreelancerRate': json['dailyFreelancerRate'] == null ? undefined : json['dailyFreelancerRate'],
        'remoteFrequency': json['remoteFrequency'] == null ? undefined : json['remoteFrequency'],
    };
}

export function BriefDetailResourceToJSON(value?: BriefDetailResource | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'currency': value['currency'],
        'projectType': value['projectType'],
        'projectDuration': ProjectDurationResourceToJSON(value['projectDuration']),
        'startDateType': value['startDateType'],
        'startDate': value['startDate'] == null ? undefined : ((value['startDate']).toISOString().substring(0,10)),
        'endDate': value['endDate'] == null ? undefined : ((value['endDate']).toISOString().substring(0,10)),
        'workingStatus': value['workingStatus'],
        'dailyFreelancerRate': value['dailyFreelancerRate'],
        'remoteFrequency': value['remoteFrequency'],
    };
}

